export class Culture {
    title: string;
    code: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/models/common/culture.ts